import gql from 'graphql-tag';

export const Search = gql`
  query search($locale: Locale!, $searchTerm: String, $tags: [String], $size: Int) {
    search(locale: $locale, searchTerm: $searchTerm, tags: $tags, size: $size) {
      results
    }
  }
`;
